import { Badge, Flex } from "@mantine/core";
import { useAuthStore } from "@/utils/stores/authStore";

interface RolePackageBadgesProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  gap?: string | number;
}

/**
 * Displays the user's role and package badges
 * @param size - Badge size (default: "md")
 * @param gap - Gap between badges (default: "xs")
 */
const RolePackageBadges = ({
  size = "md",
  gap = "xs",
}: RolePackageBadgesProps) => {
  const { role, businessInfo } = useAuthStore();
  const packageName = businessInfo?.packageName || "";

  const getRoleDisplayName = (role: string | null): string => {
    switch (role) {
      case "owner":
        return "Owner";
      case "team_lead":
        return "Team Lead";
      case "team_member":
        return "Team Member";
      case "client":
        return "Client";
      default:
        return "UNKNOWN";
    }
  };

  return (
    <Flex gap={gap} align="center">
      <Badge
        size={size}
        variant="light"
        color="gray"
        radius="md"
        tt="capitalize"
        fw={500}
      >
        {getRoleDisplayName(role || null)}
      </Badge>
      {packageName && (
        <Badge
          size={size}
          variant="light"
          color="blue"
          radius="md"
          tt="uppercase"
          fw={500}
        >
          {packageName}
        </Badge>
      )}
    </Flex>
  );
};

export default RolePackageBadges;
